
import { Injectable } from '@angular/core';
import { Cliente } from '../shared/model/ajustesUsuario/cliente.model';
import { UrlConstantes } from '../utilerias/constantes/urlconstantes';
import { Proyecto } from '../shared/model/gestion-proyectos/proyecto';
import { Base } from '../shared/model/core/base.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ConsultaList } from '../shared/model/core/ConsultaList.model';
import { Seguimiento } from '../shared/model/gestion-proyectos/seguimiento/seguimiento';
import { Avance } from '../shared/model/gestion-proyectos/seguimiento/avance';
import { Riesgo } from '../shared/model/gestion-proyectos/seguimiento/riesgo';
import { Issue } from '../shared/model/gestion-proyectos/seguimiento/issue';
import { nuevosAlcances } from '../shared/model/gestion-proyectos/nuevosAlcances';
import { environment } from 'src/environments/environment';
import { comentariosAvances } from '../shared/model/gestion-proyectos/comentariosAvances';
import { HistorialDCambios } from '../clientes/models/historialDeCambios';
import { Empleado } from '../shared/model/empleado/empleado.model';
import { seguimientosRiesgos } from '../shared/model/gestion-proyectos/seguimientoRiesgo';
import { Riesgos } from '../shared/model/gestion-proyectos/riesgos/riesgo.model';
import { Discusion } from '../shared/model/gestion-proyectos/discusion';
import { CasoDeUsoBean } from '../shared/casosDeUso';
import { SprintModel } from '../shared/model/gestion-proyectos/sprint';
import { HistoriaDeUsuario } from '../shared/historiaUsuario';
import { Observable } from 'rxjs';
import { ProductoCliente } from '../shared/model/gestion-proyectos/productoCliente';
import { Servicio } from '../shared/model/gestion-proyectos/servicio';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class ProyectosService {
  versionesPorTipo: Map<number, string>;

  constructor(private httpClient: HttpClient) {
    const versionesLocalStorage = localStorage.getItem('versionesPorTipo');
    this.versionesPorTipo = versionesLocalStorage ? new Map(JSON.parse(versionesLocalStorage)) : new Map<number, string>();
  }

  findAllCustomers(customer: Cliente) {
    return this.httpClient.post<Array<Cliente>>(UrlConstantes.findAllCustomers, customer);
  }

  obtenerProspecto(customer: Cliente) {
    return this.httpClient.post<Array<Cliente>>(UrlConstantes.obtenerProspecto, customer);
  }

  obtenerProductosCliente(idCliente: number) {
    return this.httpClient.post<ConsultaList<ProductoCliente>>(UrlConstantes.obtenerProductosCliente, idCliente);
  }

  obtenerServicios() {
    return this.httpClient.post<ConsultaList<Servicio>>(UrlConstantes.obtenerServicios, {});
  }
  /**
   * Llamado de servicio para guardado de un nuevo proyecto
   * @param projectObject
   * @returns Retorna el objeto base con el codigo de error correspondiente a la operacion.
   */
  // saveProyect(projectObject: Proyecto) {
  //   return this.httpClient.post<Base>(UrlConstantes.guardarProyecto, projectObject);
  // }
  saveProyect(proyecto: Proyecto) {
    return this.httpClient.post<Base>(UrlConstantes.guardarProyecto, proyecto);
  }

  //Cancelar oportunidad
  cancelarOportunidad(proyecto: Proyecto) {
    return this.httpClient.post<Base>(UrlConstantes.cancelarProyectoOp, proyecto);
  }
  getProjectsUser(request: any) {
    return this.httpClient.post<any>(UrlConstantes.consultaProyectoXUsuario, request);
  }
  getProjectsFilter(request: ConsultaList<Proyecto>) {
    return this.httpClient.post<ConsultaList<Proyecto>>(UrlConstantes.consultaProyectosPorFiltro, request);
  }
  getProjectsWithPagination(request: ConsultaList<Proyecto>) {
    return this.httpClient.post<ConsultaList<Proyecto>>(UrlConstantes.consultaProyectosConPaginacion, request);
  }

  getProjectsPagFilter(request: ConsultaList<Proyecto>) {
    return this.httpClient.post<ConsultaList<Proyecto>>(UrlConstantes.CONSULTA_LISTAPROYECTOS_CON_PAG_FILTROS, request);
  }

  getListaSeguimientoProyecto(idEtapa: number) {
    return this.httpClient.post<any>(UrlConstantes.CONSULTA_LISTA_SEG_XETAPA, idEtapa);
  }
  getSeguimientoId(seg: Seguimiento) {
    return this.httpClient.post<Seguimiento>(UrlConstantes.CONSULTA_SEG_XID, seg);
  }
  guardarAvanceProyecto(req: any) {
    return this.httpClient.post<any>(UrlConstantes.GUARDAR_AVANCE_PROYECTO, req);
  }

  guardaIssueSeg(issue: Issue) {
    return this.httpClient.post<Issue>(UrlConstantes.GUARDAR_ISSUE_SEG, issue);
  }
  guardaRiesgoSeg(riesgo: Riesgo) {
    return this.httpClient.post<Riesgo>(UrlConstantes.GUARDAR_RIESGO_SEG, riesgo);
  }
  eliminaAvanceSeg(avance: Avance) {
    return this.httpClient.post<Avance>(UrlConstantes.ELIMINAR_AVANCE_SEG, avance);
  }
  eliminaIssueSeg(issue: Issue) {
    return this.httpClient.post<Issue>(UrlConstantes.ELIMINAR_ISSUE_SEG, issue);
  }
  eliminaRiesgoSeg(riesgo: Riesgo) {
    return this.httpClient.post<Riesgo>(UrlConstantes.ELIMINAR_RIESGO_SEG, riesgo);
  }

  /**
   * Llamado de servicio para guardado de un nueva alcance asociado al proyecto
   * @param projectObject
   * @returns Retorna el objeto base con el codigo de error correspondiente a la operacion.
   */
  guardarAlcance(alcanceObj: nuevosAlcances) {
    return this.httpClient.post<Base>(UrlConstantes.GUARDAR_NUEVOS_ALCANCES, alcanceObj);
  }

  consultaAlcance(id_proyecto: string) {
    return this.httpClient.post<ConsultaList<nuevosAlcances>>(
      API_URL + 'controller/consultaAlcance.do',
      id_proyecto,
      {}
    );
  }


  guardarComentario(comentario: comentariosAvances) {
    return this.httpClient.post<comentariosAvances>(UrlConstantes.GUARDAR_COMENTARIO_AVANCES, comentario, {});
  }

  consultaComentariosAv(id_proyecto: number) {
    return this.httpClient.post<ConsultaList<comentariosAvances>>(
      API_URL + 'controller/consultaComentariosDeAvances.do',
      id_proyecto,
      {}
    );
  }

  guardarHistorialCambio(objetoHistorial: HistorialDCambios) {
    return this.httpClient.post<Base>(UrlConstantes.GUARDAR_HISTORIAL_CAMBIO, objetoHistorial);
  }

  consultaEmpleados() {
    return this.httpClient.post<ConsultaList<Empleado>>(
      API_URL + 'controller/consultaEmpleadosTodsAreas.do',
      {}
    );
  }

  consultaHistoCambiosPaginacion(consultaObject: ConsultaList<HistorialDCambios>) {
    return this.httpClient.post<ConsultaList<HistorialDCambios>>(UrlConstantes.consultaHistoCambiosPaginacion, consultaObject);
  }

  conultaSeguimientos(filtro: ConsultaList<seguimientosRiesgos>) {
    return this.httpClient.post<ConsultaList<seguimientosRiesgos>>(UrlConstantes.CONSULTA_SEGUIMIENTOS_RIESGOS, filtro);
  }

  guardarSeguimientoRiesgo(seguimiento: seguimientosRiesgos) {
    return this.httpClient.post<seguimientosRiesgos>(UrlConstantes.GUARDAR_SEGUIMIENTO_RIESGO, seguimiento, {});
  }

  //Gestion de riesgos
  guardaRiesgo(riesgo: Riesgos) {
    return this.httpClient.post<Riesgo>(UrlConstantes.guardaRiesgo, riesgo);
  }
  consultaGeneral(url: string) {
    return this.httpClient.post<ConsultaList<any>>(url, {});
  }

  consultaRiesgoPaginacion(consultaObject: ConsultaList<Riesgos>) {
    return this.httpClient.post<ConsultaList<Riesgos>>(UrlConstantes.consultaRiesgoPaginacion, consultaObject);
  }

  getReporteRiesgosExcel(httpParams: HttpParams) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    return this.httpClient.get(UrlConstantes.CONSULTA_LISTA_RIESGOS_EN_EXCEL, {
      params: httpParams,
      headers: headers,
      responseType: 'blob'
    });
  }



  incrementarVersion(idTipo: number): void {
    const versionActual = this.versionesPorTipo.get(idTipo) || '1.0';
    const [mayor, menor] = versionActual.split('.').map(Number);

    if (menor < 9) {
      this.versionesPorTipo.set(idTipo, `${mayor}.${menor + 1}`);
    } else {
      this.versionesPorTipo.set(idTipo, `${mayor + 1}.0`);
    }

    localStorage.setItem('versionesPorTipo', JSON.stringify(Array.from(this.versionesPorTipo.entries())));
  }

  proyectosxRecursos(request: ConsultaList<Proyecto>) {
    return this.httpClient.post<ConsultaList<Proyecto>>(UrlConstantes.CONSULTA_PROYECTOS, request);
  }

  consultaEpicassPaginacion(consultaObject: ConsultaList<CasoDeUsoBean>) {
    return this.httpClient.post<ConsultaList<CasoDeUsoBean>>(UrlConstantes.CONSULTA_TAREA_X_PROYECTO, consultaObject);
  }

  consultaDiscusion(request: ConsultaList<Discusion>) {
    return this.httpClient.post<ConsultaList<Discusion>>(UrlConstantes.CONSULTA_DISCUSION, request);
  }

  consultaAreaxUsuario() {
    return this.httpClient.post<any>(UrlConstantes.consultaAreaxUsuario, {});
  }
  consultaSprintPaginacion(consultaObject: ConsultaList<SprintModel>) {
    return this.httpClient.post<ConsultaList<SprintModel>>(UrlConstantes.consultaSprintPaginacion, consultaObject);
  }

  consultaHUPendientes(idProyecto: number) {
    return this.httpClient.post<ConsultaList<HistoriaDeUsuario>>(UrlConstantes.CONSULTA_HU_PENDIENTES, idProyecto);
  }

  guardaActualizaSBacklog(hu: SprintModel) {
    return this.httpClient.post<SprintModel>(UrlConstantes.GUARDA_SPRINT_BACKLOG, hu);
  }

  consultaUltSeguimiento(idRiesgo: number) {
    return this.httpClient.post<ConsultaList<seguimientosRiesgos>>(
      API_URL + 'controller/consultaUltEstatusRiesgo.do',
      idRiesgo,
      {}
    );
  }

  consultaProyectoMongo( request: ConsultaList<Proyecto>) { 
    return this.httpClient.post<any>(UrlConstantes.CONSULTAR_PROYECTOS_MONGO, request);
  }

  generarIdProyecto(idExistente: number, productoSeleccionadoId: number, idIngresado: number): Observable<string> {
    return this.httpClient.post<string>(UrlConstantes.GENERAR_ID_PROYECTO, { idExistente, productoSeleccionadoId, idIngresado });
}


guardaProductoCliente(producto: ProductoCliente) {
  return this.httpClient.post<ProductoCliente>(UrlConstantes.guardaProductoCliente, producto);
}

  consultarResumenSeguimientoProyectos(request?: {
    estatus?: string;
    idCliente?: number | null;
    idLider?: number | null;
    fecha?: string | null;
  }) {
    const body = {
      estatus: request?.estatus ? request.estatus.toUpperCase() : null,
      idCliente: request?.idCliente ?? null,
      idLider: request?.idLider ?? null,
      fecha: request?.fecha ?? null,
    };

    return this.httpClient.post<any>(
      UrlConstantes.CONSULTAR_RESUMEN_SEGUIMIENTO_PROYECTOS,
      body
    );
  }

  consultarFiltrosSeguimientoProyectos() {
    return this.httpClient.get<any>(
      UrlConstantes.CONSULTAR_FILTROS_SEGUIMIENTO_PROYECTOS
    );
  }

  consultarDetalleSeguimientoProyecto(projectId: string) {
    return this.httpClient.post<any>(
      UrlConstantes.CONSULTAR_DETALLE_SEGUIMIENTO_PROYECTO,
      { projectId }
    );
  }

  consultarResumenSeguimientoServicios(request?: {
    idTipoServicio?: number | null;
    idCliente?: number | null;
    idResponsable?: number | null;
    anioVigencia?: number | null;
  }) {
    const body = {
      idTipoServicio: request?.idTipoServicio ?? null,
      idCliente: request?.idCliente ?? null,
      idResponsable: request?.idResponsable ?? null,
      anioVigencia: request?.anioVigencia ?? null,
    };

    return this.httpClient.post<any>(
      UrlConstantes.CONSULTAR_RESUMEN_SEGUIMIENTO_SERVICIOS,
      body
    );
  }

  consultarFiltrosSeguimientoServicios() {
    return this.httpClient.get<any>(
      UrlConstantes.CONSULTAR_FILTROS_SEGUIMIENTO_SERVICIOS
    );
  }

  guardarSeguimientoServicio(request: {
    idProyecto: string;
    descripcion: string;
    horasAdicionales?: number;
  }) {
    return this.httpClient.post<any>(
      UrlConstantes.GUARDAR_SEGUIMIENTO_SERVICIO,
      request
    );
  }
}
